import { Component, OnInit, inject, DestroyRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Machine } from '@shared/entities/machine';
import { MachineFilter } from '@shared/entities/machineFilter';
import { MachineFilterURL, MachineService } from '@shared/services/api/machine.service';
import { MachineFiltersService } from '@shared/services/api/machine-filters.service';
import { Paginate } from '@shared/entities/paginate';
import { FilterSelectedEventType } from '@shared/models/types';
import { ThemeService } from '../services/theme.service';

@Component({
  selector: 'app-machine-modules',
  templateUrl: './machine-modules.component.html',
  styleUrl: './machine-modules.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MachineModulesComponent implements OnInit {
  private _destroyRef = inject(DestroyRef);
  private _cdr = inject(ChangeDetectorRef);
  private _themeService = inject(ThemeService);
  private _machineService = inject(MachineService);
  private _machineFiltersService = inject(MachineFiltersService);
  private _router = inject(Router);

  isLight = true;
  allMachines$: Observable<Machine[]>;
  machineFilters$: Observable<MachineFilter> = this._machineFiltersService.all$;

  prevPage?: number;
  currentPage = 1;
  nextPage?: number;
  totalPages?: number;

  constructor() {
    this.allMachines$ = this._machineService.all$.pipe(
      switchMap((paginated: Paginate<Machine>) => {
        this.prevPage = paginated.prevPage;
        this.currentPage = paginated.currentPage ?? 1;
        this.nextPage = paginated.nextPage;
        this.totalPages = paginated.totalPage;
        this._cdr.markForCheck();
        return of(paginated.data);
      })
    );
  }

  ngOnInit(): void {
    this._machineService.refresh(1);

    this._themeService.isLight$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((isLight) => {
      this.isLight = isLight;
      this._cdr.markForCheck();
    });
  }

  /** Cascading filters: selecting an account narrows the serial number options and vice versa. */
  onSelectedFilter(filters: FilterSelectedEventType[]): void {
    const filtersName = filters.reduce((acc: any, filter: FilterSelectedEventType) => {
      acc[filter.name] = filter.selectedValue;
      return acc;
    }, {});
    this._machineFiltersService.filters = filtersName as MachineFilterURL;
    this._machineService.filters = filtersName as MachineFilterURL;
  }

  onPageSelected(page: number): void {
    this._machineService.refresh(page);
  }

  goBack(): void {
    this._router.navigate(['/user']);
  }

  getYear(): number {
    return new Date().getFullYear();
  }
}
